export default __webpack_public_path__ + "static/media/background_molecule.e8c87d79.jpg";